import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M414-185v-100H145q-32 0-56-24-23-23-23-56v-409q0-33 23-57 24-23 56-23h670q33 0 56 23 24 24 24 57v409q0 33-24 56-23 24-56 24H546v100h47q16 0 28 11 11 12 11 29t-11 28q-12 11-28 11H367q-16 0-28-11t-11-29q0-16 11-28 12-11 28-11h47ZM145-365h670v-409H145v409Zm0 0v-409 409Z"/>',
  f: '<path d="M414-185v-100H145q-32 0-56-24-23-23-23-56v-409q0-33 23-57 24-23 56-23h670q33 0 56 23 24 24 24 57v409q0 33-24 56-23 24-56 24H546v100h47q17 0 28 11 11 12 11 29 0 16-11 28-11 11-28 11H367q-17 0-28-11-11-12-11-28 0-17 11-29 11-11 28-11h47Z"/>',
};

export default data;
